import React, { useEffect } from 'react';
import { X, TrendingUp, Target, Flame, Trophy } from 'lucide-react';
import { trackStatsViewed } from '../../core/utils/analytics';
import './StatsModal.css';

export default function StatsModal({ isOpen, onClose, userProfile }) {
  // Track stats view when modal opens
  useEffect(() => {
    if (isOpen) {
      trackStatsViewed();
    }
  }, [isOpen]);

  if (!isOpen) return null;

  const stats = userProfile?.stats || {
    gamesPlayed: 0,
    gamesWon: 0,
    gamesLost: 0,
    currentStreak: 0,
    maxStreak: 0,
    avgScore: 0
  };

  const winRate = stats.gamesPlayed > 0
    ? Math.round((stats.gamesWon / stats.gamesPlayed) * 100)
    : 0;

  // Close on overlay click
  const handleOverlayClick = (e) => {
    if (e.target.className === 'stats-modal-overlay') {
      onClose();
    }
  };

  return (
    <div className="stats-modal-overlay" onClick={handleOverlayClick}>
      <div className="stats-modal">
        {/* Header */}
        <div className="stats-modal-header">
          <h2>Your Stats</h2>
          <button
            className="stats-modal-close"
            onClick={onClose}
            aria-label="Close"
          >
            <X size={24} />
          </button>
        </div>

        {/* Username Display */}
        <div className="stats-username">
          {userProfile?.username || 'Player'}
        </div>

        {/* Stats Grid */}
        <div className="stats-grid">
          {/* Games Played */}
          <div className="stat-card">
            <div className="stat-icon">
              <Target size={24} />
            </div>
            <div className="stat-value">{stats.gamesPlayed}</div>
            <div className="stat-label">Games Played</div>
          </div>

          {/* Games Won */}
          <div className="stat-card">
            <div className="stat-icon">
              <Trophy size={24} />
            </div>
            <div className="stat-value">{stats.gamesWon}</div>
            <div className="stat-label">Games Won</div>
          </div>

          {/* Win Rate */}
          <div className="stat-card">
            <div className="stat-icon">
              <TrendingUp size={24} />
            </div>
            <div className="stat-value">{winRate}%</div>
            <div className="stat-label">Win Rate</div>
          </div>

          {/* Current Streak */}
          <div className="stat-card">
            <div className="stat-icon">
              <Flame size={24} />
            </div>
            <div className="stat-value">{stats.currentStreak}</div>
            <div className="stat-label">Current Streak</div>
          </div>

          {/* Max Streak */}
          <div className="stat-card highlight">
            <div className="stat-icon">
              <Flame size={24} />
            </div>
            <div className="stat-value">{stats.maxStreak}</div>
            <div className="stat-label">Best Streak</div>
          </div>

          {/* Average Score */}
          <div className="stat-card highlight">
            <div className="stat-icon">
              <Target size={24} />
            </div>
            <div className="stat-value">
              {stats.avgScore > 0 ? stats.avgScore.toFixed(1) : '0.0'}
            </div>
            <div className="stat-label">Avg Guesses</div>
          </div>
        </div>

        {/* Close Button */}
        <button className="stats-modal-button" onClick={onClose}>
          Close
        </button>
      </div>
    </div>
  );
}
